import "./index.scss";

import { Box, Modal, Stack } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/images/square-buttons/close-small.svg";
import ConfirmationBox from "components/ConfirmationBox";
import ScreenLoader from "components/ScreenLoader";
import { MSG_OPERATION_FAILED } from "constants/index";
import { TMember } from "models/member";
import { createMember, updateMember } from "modules/member/memberServices";
import { useCallback, useState } from "react";
import { toast } from "react-toastify";

import MemberForm from "../MemberForm";

const MemberFormModal = (props: {
  open: boolean;
  onClose: any;
  memberId?: number;
  switchToTab?: string;
}) => {
  const { open, onClose, memberId, switchToTab } = props;
  const [memberToRegister, setMemberToRegister] = useState<TMember>(null);
  const [loading, setLoading] = useState(false);
  const [showDataWillBeLostModal, setShowDataWillBeLostModal] = useState(false);

  //#region event handlers
  const handleCloseModal = useCallback(
    (isRefreshNeeded = false) => {
      if (isRefreshNeeded) {
        onClose(isRefreshNeeded);
      } else {
        setShowDataWillBeLostModal(true);
      }
    },
    [onClose, setShowDataWillBeLostModal]
  );

  const onCloseConfirm = (discardChanges = false) => {
    if (discardChanges) {
      setShowDataWillBeLostModal(false);
      onClose(false);
    } else {
      setShowDataWillBeLostModal(false);
    }
  };
  const setLoadingState = (state: boolean) => {
    setLoading(state);
  };

  const handleMemberObjectUpdated = async (data: TMember, isReadyToSave: boolean = false) => {
    const memberPromise = new Promise(async function (resolve, reject) {
      setMemberToRegister(data);
      if (isReadyToSave) {
        setLoading(true);
        const createOrUpdateAPI = memberId ? updateMember : createMember;
        const result = await createOrUpdateAPI(data, null, setLoadingState);
        console.log(`handleMemberObjectUpdated() result is ${JSON.stringify(result)}`);
        const _res = result["success"];
        if (_res === true) {
          resolve(`memberPromise succeeded with result ${JSON.stringify(_res)}`);
          setLoading(false);
          handleCloseModal(true);
        } else {
          setLoading(false);
          reject(`memberPromise failed with result ${JSON.stringify(_res)}`);
          return;
        }
      }
    });
    await memberPromise;
  };
  //#endregion event handlers

  return (
    <>
      <Modal
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
        open={open}
        onClose={() => handleCloseModal(false)}
        className="modal-style-1"
      >
        <Stack className="personal-details-modal-container">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            marginBottom="40px"
            className="header"
          >
            <h1>{memberId ? `Edit` : `Add`} Member</h1>
            <DeleteIcon width="24px" height="24px" onClick={() => handleCloseModal(false)} />
          </Stack>
          {loading && <ScreenLoader isScreenLoader />}
          <Box className={loading && `isHidden`}>
            <MemberForm
              onClose={handleCloseModal}
              open={open}
              sendMemberBackCallback={handleMemberObjectUpdated}
              memberId={memberId}
              switchToTab={switchToTab}
            />
          </Box>
        </Stack>
      </Modal>
      <ConfirmationBox
        open={showDataWillBeLostModal}
        onClose={onCloseConfirm}
        title={"Discard Changes?"}
        message={<>If answered Yes, all information filled will be lost.</>}
        type={"confirmation"}
      />
    </>
  );
};

export default MemberFormModal;
